export default {
  currentUser: {},
  currentCompany: 0,
  currentReports: {},
  currentReportName: '',
  qualityUpperLimit: 1.05,
  qualityLowerLimit: 0.95,
  statuses: [],
  workOrderStatus: [],
  picklistStatus: [],
  picklistUnits: [],
  workOrderUnit: [],
  workOrderResponsible: [],
  responsibleSeller: [],
  perPage: 50,
  selectedFlataRows: [],
  selectedFlata: [],
  selectedReportRows: {},
  routeData: {},
  nodeEnv: process.env.NODE_ENV,
  apiUrl: process.env.API_ENDPOINT,
  stockMode: null,
  stockQueue: [],
  newReport: {
    id: null,
    status: 1,
    currentStep: 1,
    header: {
      name: '',
      address: '',
      city: '',
      bestallare: '',
      customerProject: '',
      sub_contractor: '',
      etapp: '',
      coil_to: '',
      isolation_to: '',
      coil_from: '',
      isolation_from: '',
      coil_twin: '',
      isolation_twin: '',
      alarm_connected: false,
      had_blueprint: false,
      density_test: false,
      discrepancy_report: false
    },
    selectedJoints: [],
    selectedJointIds: [],
    jointDetails: {},
    unmatchedRows: [],
    customerConfig: null
  },
  fieldWork: {
    reports: [],
    activeReportId: null,
    editingRowId: null
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js